<div class="flexbox-parent">
  <div fxLayout="row" fxLayoutAlign="center center" style="height: 60vh;  ">
    <div style="text-align:center;">
      <app-zero-image name="checkinForm" /><br>
      <h5 class="ma-0">{{'NO_CUSTOMER_SIGNUP_TEMPLATE' | translate}}</h5><br>
      <button mat-raised-button color="accent" (click)="create()">{{'ADD_CUSTOMER_SIGNUP_TEMPLATE' | translate}}</button>
    </div>
  </div>
</div>